import { render, staticRenderFns } from "./CreateEventBattles.vue?vue&type=template&id=71d61c5e&scoped=true"
import script from "./CreateEventBattles.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventBattles.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventBattles.vue?vue&type=style&index=0&id=71d61c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d61c5e",
  null
  
)

export default component.exports